import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ColletteButton } from "@collette-travel/collette-common-controls";
import { useTranslations } from "next-intl";
import getResponsiveSpacing  from "@/utils/repsonsive-spacing-utils";
import { Link } from "@/i18n/routing";



interface RelatedBlogCardProps {
  item: {
    id: string;
    title: string;
    summary: string;
    url: string;
  };
  index?: number;
}


const RelatedBlogCard: React.FC<RelatedBlogCardProps> = ({ item, index }) => {
  const t = useTranslations("DESTINATIONS");
  const testId = `related-blog-card${index !== undefined ? `-${index}` : ""}`;
  const [spacing, setSpacing] = useState(() =>
    getResponsiveSpacing({
      maxScreen: 1430,
      minScreen: 1199,
      maxSpacing: 1.75,
      minSpacing: 1.75,
      stepPx: 50,
      stepDrop: 1
    })
  );

  useEffect(() => {
    const handleResize = () =>
      setSpacing(
        getResponsiveSpacing({
          maxScreen: 1430,
          minScreen: 1199,
          maxSpacing: 4.6,
          minSpacing: 1.75,
          stepPx: 50,
          stepDrop: 1
        })
      );
    window.addEventListener("resize", handleResize);
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Card
      component="article"
      data-testid={testId}
      sx={{
        backgroundColor: "background.cool_strong",
        borderRadius: "2rem",
        boxShadow: "var(--theme-shadows-0)",
        transition: "width 0.2s, background-color 0.2s",
        "&:has(a:hover)": {
          backgroundColor: "background.cool"
        }
      }} 
    >
      <CardActionArea component={Link} href={item.url} sx={{ width: "100%", height: {lg: "411.69px", md: "100%" } }}>
        <CardContent>
          <Stack
            spacing={{ lg: spacing, md: 1.75, xs: 1.75 }}
            sx={{
              padding: {
                legacyDesktop: "3.2 2rem",
                legacyTablet: "2rem",
                legacyMobile: "2rem"
              },
              gap: "1.4rem",
              alignItems: "flex-start",
              justifyContent: "center",
              alignSelf: "stretch"

            }}>
            <Typography variant="subtitle_lg" component="p"
              sx={{
                color: "text.primary",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "3rem"
              }}
              data-testid={`${testId}-subtitle`}
            >
              {t("Travel Blog").toUpperCase()}
            </Typography>
            <Typography
              variant="h4"
              component='h3'
              data-testid={`${testId}-title`}
            >
              {item.title}
            </Typography>
            <Typography variant="subtitle_lg" component="p"
              sx={{
                color: "text.primary",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "3rem"
              }}
              data-testid={`${testId}-summary`}
            >
              {item.summary}
            </Typography>
            <ColletteButton
              variant="outlined"
              size="large"
              label={t("Read More")}
              testId={`related-content-travel-blog-cta-button${index !== undefined ? `-${index}` : ""}`}
              sx={{
                alignSelf: "flex-start",
                color: "primary.main",
                borderColor: "primary.main",
                backgroundColor: "background.default",
                textTransform: "none"
              }} />

          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default RelatedBlogCard;